import dayjs from "dayjs";
import "dayjs/locale/pl";

//@todo: Add unit tests
export const getHourMinuteFromDate = (date: string): string => {
  const formattedTime = dayjs(date).format("HH:mm");
  return formattedTime === "23:59" ? "00:00" : formattedTime;
};
